export default __webpack_public_path__ + "img/dEeFYClW.ac0da11a.svg";